import { render, staticRenderFns } from "./SurgeryOther.vue?vue&type=template&id=3f31f058&scoped=true&"
import script from "./SurgeryOther.vue?vue&type=script&lang=js&"
export * from "./SurgeryOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f31f058",
  null
  
)

export default component.exports